/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Meeting_Notetaker_Issue_Waiting_Room_UntilInputs */



/**
* | output |
* | --- |
* | "Wundo waits until {time}." |
*
* @param {Meeting_Notetaker_Issue_Waiting_Room_UntilInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_room_until = /** @type {((inputs: Meeting_Notetaker_Issue_Waiting_Room_UntilInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_Room_UntilInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Wundo wacht nog tot ${i?.time}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Wundo attend jusqu'à ${i?.time}.`)
	return /** @type {LocalizedString} */ (`Wundo waits until ${i?.time}.`)
});